import { useState, useContext } from "react";
import { Formik } from "formik";
import { Box, Typography } from "@mui/material";
import css from "../../css/login.module.css";
import { Link, useNavigate } from "react-router-dom";
import { apiFormRequest } from "../../api";
import { NotificationContext } from "../../providers/notification";
import { CiLock as LockIcon, CiUnlock as UnlockIcon } from "react-icons/ci";
import { GrFormCheckmark as CorrectIcon } from "react-icons/gr";
import { HiXMark as IncorrectIcon } from "react-icons/hi2";

const lightText: string = "#D2EAE1";

const Login = () => {
  const [password, set_password] = useState<string>("");
  const [confirm_password, set_confirm_password] = useState<string>("");
  const [loading, set_loading] = useState<boolean>(false);
  const { showNotification } = useContext(NotificationContext);
  // const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [isValid, setIsValid] = useState(false);
  const [password_status, set_password_status] = useState<any>({
    length: false,
    alphabet: false,
    number: false,
    special_char: false,
    password_match: false,
  });

  const handlePassword = () => {
    setShowPassword(!showPassword);
  };

  const validatePassword = (e: any) => {
    const val = e.target.value;
    let length = false,
      alphabet = false,
      numb = false;
    let special_char = false;
    if (val.length > 7 && val.length <= 20) {
      length = true;
    }
    if (val.match(/[a-z]/) && val.match(/[A-Z]/)) {
      alphabet = true;
    }
    if (val.match(/[0-9]/)) {
      numb = true;
    }
    if (val.match(/\W/)) {
      special_char = true;
    }
    set_password(val);
    set_password_status({
      ...password_status,
      length,
      alphabet,
      number: numb,
      special_char,
    });
  };
  const validatePassword2 = (e: any) => {
    const val = e.target.value;
    let password_match = false;
    if (password == val) {
      password_match = true;
    }
    set_confirm_password(val);
    set_password_status({ ...password_status, password_match });
  };

  const handleChangePassword = (e: any) => {
    e.preventDefault();
    let body = new FormData();
    let url = window.location.search;
    let searchParams = new URLSearchParams(url);
    let Email: any = searchParams.get("email");

    if (
      !password_status.length ||
      !password_status.alphabet ||
      !password_status.number ||
      !password_status.special_char ||
      !password_status.password_match
    ) {
      return;
    }

    if (!Email) {
      showNotification({
        message: "Please use the link sent to your email",
        type: "error",
      });
      return;
    }

    set_loading(true);
    body.append("Password", password);
    body.append("ConfirmPassword", confirm_password);
    body.append("Email", Email);

    apiFormRequest("api/Authentication/resetpassword", body)
      .then((data) => {
        if (data.StatusCode == 200) {
          showNotification({
            message: data.Message || "Password Changed Successfully",
            type: "success",
          });
          let timer: any = setTimeout(() => {
            navigate("/login");
            clearTimeout(timer);
          }, 3000);
        } else {
          showNotification({
            message: data.Message || "Password Cannot be changed",
            type: "error",
          });
        }
        set_loading(false);
      })
      .catch((error) => {
        showNotification({
          message:
            error.Message || error.name || "Error occurred try again later",
          type: "error",
        });
        set_loading(false);
      });
  };

  const navigate = useNavigate();

  return (
    <Box component="form" className={css.form} onSubmit={handleChangePassword}>
      <Typography
        component="h1"
        children={"Change Password"}
        sx={{ fontWeight: "bold", color: "white", fontSize: "22px" }}
        align="center"
      />
      <Typography
        component="p"
        children={"Take a step ahead to track applications"}
        sx={{ color: lightText, fontSize: "12px" }}
        align="center"
        mt={1}
        mb={5}
      />
      <label>
        <div>New Password</div>
        <input
          value={password}
          onChange={validatePassword}
          type={showPassword ? "text" : "password"}
          placeholder="New Password "
          required={true}
        />
        <span onClick={handlePassword}>
          {showPassword ? <UnlockIcon /> : <LockIcon />}
        </span>
      </label>
      <label>
        <div> Confirm Password</div>
        <input
          value={confirm_password}
          onChange={validatePassword2}
          type={showPassword ? "text" : "password"}
          placeholder="Confirm Password"
          required={true}
        />
        <span onClick={handlePassword}>
          {showPassword ? <UnlockIcon /> : <LockIcon />}
        </span>
        {/* modified here */}
        <p className={css.password}>
          <span className={password_status.length ? css.correct : ""}>
            {password_status.length ? <CorrectIcon /> : <IncorrectIcon />}8-20
            characters
          </span>
          <span className={password_status.alphabet ? css.correct : ""}>
            {password_status.alphabet ? <CorrectIcon /> : <IncorrectIcon />}{" "}
            Upper & Lowercase
          </span>
          <span className={password_status.number ? css.correct : ""}>
            {password_status.number ? <CorrectIcon /> : <IncorrectIcon />}
            Number(s)
          </span>
          <span className={password_status.special_char ? css.correct : ""}>
            {password_status.special_char ? <CorrectIcon /> : <IncorrectIcon />}
            Special character(s)
          </span>
          <span className={password_status.password_match ? css.correct : ""}>
            {password_status.password_match ? (
              <CorrectIcon />
            ) : (
              <IncorrectIcon />
            )}
            Password must match
          </span>
        </p>
      </label>
      <input
        type="submit"
        disabled={loading}
        value={`${!loading ? "Change Password" : "Loading..."}`}
      />
      <Typography
        component={"div"}
        sx={{
          color: lightText,
          mt: 3,
          mb: 3,
          fontSize: "12px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <span>Did you forgot your password?</span>
        <Link to="/forgot-password" style={{ color: "white" }}>
          Reset Password
        </Link>
      </Typography>
    </Box>
  );
};

export default Login;
